import { FieldProps, getIn } from 'formik';
import ErrorMessage from '../atoms/ErrorMessage';
import Select, { SelectProps } from '../atoms/Select';

type SelectFieldProps = FieldProps & SelectProps & { label: string; 'data-test-id': string };

const SelectField = ({ field, form: { touched, errors, setFieldValue }, meta, label, ...props }: SelectFieldProps) => {
  const error = getIn(touched, field.name) && getIn(errors, field.name);
  const { 'data-test-id': dataTestId } = props;

  return (
    <>
      <Select
        placeholder={label}
        {...props}
        {...field}
        hasError={!!error}
        onChange={value => {
          props.onChange?.(value);
          setFieldValue(field.name, value);
        }}
      />
      <ErrorMessage label={label} error={error} dataTestId={dataTestId} />
    </>
  );
};

export default SelectField;
